import { render, staticRenderFns } from "./PitSvg.vue?vue&type=template&id=8d4c669c&scoped=true"
import script from "./PitSvg.vue?vue&type=script&lang=js"
export * from "./PitSvg.vue?vue&type=script&lang=js"
import style0 from "./PitSvg.vue?vue&type=style&index=0&id=8d4c669c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4c669c",
  null
  
)

export default component.exports